// @ts-nocheck
import React, { useEffect, useState } from 'react';
import sliderJS from 'js/slider';
import { PICS_URL } from 'api';
import logo from '../../assets/images/main-picture.svg';
import resource from '../../assets/images/res-packich.png';

import {
  advantagesFunction,
  sliderFunction,
  statisticsFunction,
} from 'js/mainBackend';
import { Helmet } from 'react-helmet';
import { IframeVideoContainer } from './IframeVideoContainer';
import { MiniBannerContainer } from './MiniBannerContainer';
import NomenclatureGroups from './NomenclatureGroups';
import { useStores } from 'hooks/useStores';
import { PopularProducts } from './PopularProducts';
import { BannerSlider } from './BannerSlider';
import { getVideoEmbedUrl } from 'utils/videoUtils';
import Seo from 'components/Seo';
import JsonLd from 'components/JsonLd';

const MainPage = () => {
  const [mainItems, setMainItems] = useState();
  const [advantagesItems, setAdvantagesItems] = useState();
  const [sliderItems, setSliderItems] = useState();
  const [banners, setBanners] = useState();
  const [statisticsItems, setStatisticsitems] = useState();
  const [isDisabledVideo, setDisabledVideo] = useState(true);
  const { api } = useStores();

  useEffect(() => {
    api.content.getPageApi('glavnaya').then((response) => {
      setMainItems(response?.init_state?.object);
      setAdvantagesItems(response?.init_state?.advantages);
      setStatisticsitems(response?.init_state?.statistics);
      setBanners(response?.init_state?.banner_slides);
      setSliderItems(response?.init_state?.slider);
    });
  }, []);

  useEffect(() => {
    if (advantagesItems?.length) {
      advantagesFunction(advantagesItems);
    }
  }, [advantagesItems]);

  useEffect(() => {
    if (statisticsItems?.length) {
      statisticsFunction(statisticsItems);
    }
  }, [statisticsItems]);

  useEffect(() => {
    if (sliderItems?.length) {
      sliderFunction(sliderItems);
      sliderJS();
    }
  }, [sliderItems]);

  useEffect(() => {
    if (mainItems) {
      if (mainItems?.youtube_video) {
        setDisabledVideo(false);
      } else {
        setDisabledVideo(true);
      }
    }
  }, [mainItems]);

  // ________  Видео  __________

  function VideoObj(container) {
    this.container = container;
    this.placeholder = container.querySelector('.video-placeholder');
    this.bg = container.querySelector('.video-placeholder__bg');
    this.txt = container.querySelector('.video-placeholder-interface__txt');
    this.btn = container.querySelector('.video-placeholder-interface__btn');
    this.video = container.querySelector('.video__iframe');

    this.btn.addEventListener('click', () => {
      this.video.style.display = 'block';
      this.placeholder.classList.add('video-placeholder--hide');
      setTimeout(() => {
        this.placeholder.style.display = 'none';
      }, 300);
    });
  }

  useEffect(() => {
    if (!isDisabledVideo) {
      const videoSections = document.querySelectorAll('.video');
      const videoObjList = [];

      for (let i = 0; i < videoSections.length; i++) {
        videoObjList.push(new VideoObj(videoSections[i]));
      }
    }
  }, [isDisabledVideo]);

  useEffect(() => {
    return () => {
      clearTimeout(window.sliderTimeout1);
      clearTimeout(window.sliderTimeout2);
      clearTimeout(window.autoSliderTimeout);
    };
  }, []);

  const mainJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Пак Пакыч",
    "url": window.location.origin,
    "description": mainItems?.seo_description || '',
  };

  return (
    <>
      <Seo seo={mainItems} />
      <JsonLd data={mainJsonLd} />
      <main id="mainPage">
        <BannerSlider banners={banners} />
        <MiniBannerContainer />
        <NomenclatureGroups />
        <PopularProducts />
        <section className="banner">
          <div className="banner-wrap">
            <div className="banner-info-wrap">
              <div className="banner-info">
                <h1 className="banner-title">
                  <span className="yellow-dash">—</span>пак пакыч
                </h1>
                <h2 className="banner-subtitle">{mainItems?.banner_title}</h2>
                <p className="banner-descr">{mainItems?.banner_text}</p>
                {!isDisabledVideo && (
                  <a className="how-gallery-button" href="#video">
                    <div className="how-gallery-button__play">
                      <div className="how-gallery-button__play-inner"></div>
                    </div>
                    <div className="how-gallery-button__text">
                      <div className="how-gallery-button__title">
                        Видео о нас
                      </div>
                    </div>
                  </a>
                )}
              </div>
            </div>
            <div className="banner-img">
              <img loading="lazy" src={logo} alt="Banner" />
            </div>
          </div>
        </section>
        <section className="benefit">
          <div className="benefit-wrap">
            <h2 className="benefit-title">
              <span className="yellow-dash">—</span>почему с нами выгодно?
            </h2>
            <div className="benefit-cards-top">
              <div className="benefit-item"></div>
              <div className="benefit-item"></div>
              <div className="benefit-item"></div>
            </div>
            <div className="benefit-cards-bottom">
              <div className="benefit-item"></div>
              <div className="benefit-item"></div>
            </div>
          </div>
        </section>
        {!isDisabledVideo && mainItems && (
          <section className="video" id="video">
            <div className="video__wrap">
              <iframe
                className="video__iframe"
                src={getVideoEmbedUrl(mainItems.youtube_video)}
                title="Video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                allowFullScreen
              ></iframe>
              <div className="video-placeholder">
                <img loading="lazy"
                  className="video-placeholder__bg"
                  src={PICS_URL + mainItems.video_preview}
                  alt="placeholder"
                />
                <div className="video-placeholder-interface">
                  <span className="video-placeholder-interface__txt">
                    О нас за 3 минуты
                  </span>
                  <button
                    className="video-placeholder-interface__btn how-gallery-button__play"
                    type="button"
                  >
                    <div className="how-gallery-button__play-inner"></div>
                  </button>
                </div>
              </div>
            </div>
          </section>
        )}
        <section className="about">
          <div className="about-background"></div>
          <div className="about-wrap">
            <div className="about-content">
              <div className="about-info">
                <h2 className="about-info__title">
                  <span className="yellow-dash">—</span>о нас
                </h2>
                <h1 className="about-info__subtitle">
                  {mainItems?.about_us_title}
                </h1>
                <p className="about-info__descr">
                  {mainItems?.about_us_content}
                </p>
              </div>
              <div className="about-card-wrap">
                <ul className="about-card">
                  <li className="about-card__item"></li>
                  <li className="about-card__item"></li>
                </ul>
                <ul className="about-card">
                  <li className="about-card__item"></li>
                  <li className="about-card__item-small"></li>
                  <li className="about-card__item-small"></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section id="useful">
          <div className="useful-wrap">
            <div className="useful-info">
              <h2 className="useful-title">
                <span className="yellow-dash">—</span> кому будет полезен наш
                ресурс
              </h2>
              <h3 className="useful-subtitle">
                {mainItems?.target_audience_title}
              </h3>
              <p className="useful-descr">
                {mainItems?.target_audience_content}
              </p>
            </div>
            <div className="useful-slider">
              <div className="useful-slides">
                <div className="useful-item">
                  <h2 className="situation-title">
                    Ситуация №1
                    <div className="situation-subtitle">Специалист</div>
                  </h2>
                  <div className="situation-dialog-upper">
                    <img loading="lazy" src="" alt="person on situation" />
                    <div className="top-bubble"></div>
                  </div>
                  <div className="situation-dialog-lower">
                    <div className="bottom-bubble"></div>
                    <img loading="lazy" src="" alt="pack packich " />
                  </div>
                </div>
                <div className="useful-item">
                  <h2 className="situation-title">
                    Ситуация №2
                    <div className="situation-subtitle">Эксперт</div>
                  </h2>
                  <div className="situation-dialog-upper">
                    <img loading="lazy" src="" alt="person on situation" />
                    <div className="top-bubble"></div>
                  </div>
                  <div className="situation-dialog-lower">
                    <div className="bottom-bubble"></div>
                    <img loading="lazy" src="" alt="pack packich " />
                  </div>
                </div>
                <div className="useful-item">
                  <h2 className="situation-title">
                    Ситуация №3
                    <div className="situation-subtitle">
                      Собственник бизнеса
                    </div>
                  </h2>
                  <div className="situation-dialog-upper">
                    <img loading="lazy" src="" alt="person on situation" />
                    <div className="top-bubble"></div>
                  </div>
                  <div className="situation-dialog-lower">
                    <div className="bottom-bubble"></div>
                    <img loading="lazy" src="" alt="pack packich " />
                  </div>
                </div>
                <div className="useful-item">
                  <h2 className="situation-title">
                    Ситуация №4
                    <div className="situation-subtitle">Конкурент</div>
                  </h2>
                  <div className="situation-dialog-upper">
                    <img loading="lazy" src="" alt="person on situation" />
                    <div className="top-bubble"></div>
                  </div>
                  <div className="situation-dialog-lower">
                    <div className="bottom-bubble"></div>
                    <img loading="lazy" src="" alt="pack packich " />
                  </div>
                </div>
                <div className="useful-item">
                  <h2 className="situation-title">
                    Ситуация №1
                    <div className="situation-subtitle">Специалист</div>
                  </h2>
                  <div className="situation-dialog-upper">
                    <img loading="lazy" src="" alt="person on situation" />
                    <div className="top-bubble"></div>
                  </div>
                  <div className="situation-dialog-lower">
                    <div className="bottom-bubble"></div>
                    <img loading="lazy" src="" alt="pack packich " />
                  </div>
                </div>
              </div>
              <div className="useful-dots-wrapper">
                <div className="useful-dots">
                  <button className="useful-dot-link" id="dot1" type="button">
                    <div className="useful-dot-active"></div>
                    <div className="useful-dot-off"></div>
                  </button>
                  <button className="useful-dot-link" id="dot2" type="button">
                    <div className="useful-dot-active"></div>
                    <div className="useful-dot-off"></div>
                  </button>
                  <button className="useful-dot-link" id="dot3" type="button">
                    <div className="useful-dot-active"></div>
                    <div className="useful-dot-off"></div>
                  </button>
                  <button className="useful-dot-link" id="dot4" type="button">
                    <div className="useful-dot-active"></div>
                    <div className="useful-dot-off"></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <IframeVideoContainer idForScroll="loyalty-program" />

        <section className="resource">
          <div className="resource-wrap">
            <div className="resource-content">
              <img loading="lazy" className="resource-banner" src={resource} alt="Resource" />
            </div>
            <div className="resource-bubble">
              <p className="resource-bubble__title">
                «Все аналоги — это перочинные
                <br /> ножики<span className="resource-yellow">
                  НАШ РЕСУРС
                </span>{' '}
                — это огромный заточенный мачете, которым мы разрубим
                недобросовестных поставщиков
              </p>
            </div>
          </div>
          <div className="mission">
            <div className="mission-wrap">
              <div className="mission-container">
                <div className="mission-info">
                  <h2 className="mission-info__title">
                    <span className="useful-dash">—</span>миссия пак пакыча
                  </h2>
                  <h3 className="mission-info__subtitle">
                    {mainItems?.mission_title}
                  </h3>
                  <p className="mission-info__descr">
                    {mainItems?.mission_content}
                  </p>
                </div>
                <div className="mission-content">
                  <h3 className="mission-content__title">
                    Мы точно знаем: <br /> компания, которая хочет быть
                    эффективной
                  </h3>
                  <div className="mission-content__subtitle">
                    <div className="mission-yellow-rec">НЕ ДОЛЖНА</div>
                  </div>
                  <div className="mission-content__descr">
                    переплачивать за упаковку!
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default MainPage;
